/*
 * @Author: wuqinfa
 * @Date: 2024-02-18 14:55:23
 * @LastEditors: Please set LastEditors
 * @Description: 
 */
import axios from 'axios';
import request from '@/utils/request';

export async function login(params: any) {
  // return request('/crm-account/account/login', {
  return request('/crm-account/account/schoolLogin', {
    method: 'POST',
    data: params,
  });
}

export async function logout() {
  return request('/crm-account/account/logout', {
    method: 'POST',
  });
}

export async function getCurrentUser() {
  return request('/crm-account/account/getCurrentAccount', {
    method: 'GET',
  });
}

export async function changePassword(params: any) {
  return request('/crm-account/account/changePassword', {
    method: 'POST',
    data: params,
  });
}

export async function getShortUrl(params: any) {
  return axios.post('https://short-url.miaocode.com/api/url/shorten', params, {
    withCredentials: false,
  });
}